import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { pick } from 'lodash-es'
import { intl } from 'lang/intl'
import createNamedActions from '../../../Audience/shared/AudienceInset/actions'
import {
  AudienceInsetComponent,
  AudienceInsetProfilesComponent,
} from '../../../Audience/shared/AudienceInset/components'

const identityOptions = {
  avatarSize: 'small',
  preferCorporateDetails: true,
  showStats: true,
}

const mapStateProps = (state, ownProps) => {
  return {
    hasMoreElements: state.webinarAudience.hasMoreElements,
    isInfiniteLoading: state.webinarAudience.isInfiniteLoading,
    profiles: state.webinarAudience[state.webinarAudience.selectedTab],
    loadingStates: state.webinarAudience.loadingStates,
    objectId: ownProps.liveId,
    objectType: 'live',
    profileComponent: AudienceInsetProfilesComponent,
    identityOptions,
    customEmptyText: ownProps.isDraft
      ? intl.formatMessage({
          defaultMessage:
            'To be able to invite people to your webinar, you should leave draft mode.',
        })
      : intl.formatMessage({
          defaultMessage: 'There is currently no audience in the webinar room.',
        }),
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = createNamedActions('webinarAudience')
  const selectedActions = pick(actions, [
    'insetInit',
    'insetLeave',
    'tabRouteChange',
    'onInfiniteLoad',
  ])

  return bindActionCreators(selectedActions, dispatch)
}

export default connect(
  mapStateProps,
  mapDispatchToProps
)(AudienceInsetComponent)
